import { T } from "./tokens";

export type MarkKind =
  | "streak"
  | "medal"
  | "bolt"
  | "silence"
  | "moon"
  | "crown"
  | "note"
  | "ear"
  | "spark";

interface MarkProps {
  kind: MarkKind;
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export function Mark({ kind, size = 22, color = T.gold, strokeWidth = 1.4 }: MarkProps) {
  const props = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };
  switch (kind) {
    case "streak":
      return (
        <svg {...props}>
          <path d="M7 21 Q5 17 8 14 Q9 16 10 15 Q9 11 12 8 Q13 11 15 11 Q15 14 17 14 Q19 18 16 21 Z" />
        </svg>
      );
    case "medal":
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="8" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="12" cy="12" r="1.2" fill={color} />
        </svg>
      );
    case "bolt":
      return (
        <svg {...props}>
          <path d="M14 3 L8 13 H12 L10 21 L16 11 H12 Z" />
        </svg>
      );
    case "silence":
      return (
        <svg {...props}>
          <path d="M12 3 L20 12 L12 21 L4 12 Z" />
          <path d="M12 7 L17 12 L12 17 L7 12 Z" />
        </svg>
      );
    case "moon":
      return (
        <svg {...props}>
          <path d="M16 4 A8 8 0 1 0 16 20 A6 6 0 0 1 16 4 Z" />
        </svg>
      );
    case "crown":
      return (
        <svg {...props}>
          <path d="M3 18 L5 8 L9 13 L12 6 L15 13 L19 8 L21 18 Z" />
          <path d="M3 21 H21" />
        </svg>
      );
    case "note":
      return (
        <svg {...props}>
          <path d="M9 19 V6 L18 4 V17" />
          <circle cx="6.5" cy="19" r="2.5" fill={color} stroke="none" />
          <circle cx="15.5" cy="17" r="2.5" fill={color} stroke="none" />
        </svg>
      );
    case "ear":
      return (
        <svg {...props}>
          <path d="M7 12 A5 5 0 1 1 17 12 Q17 16 14 17 Q12 18 12 21" />
          <circle cx="11" cy="12" r="1.5" fill={color} stroke="none" />
        </svg>
      );
    case "spark":
      return (
        <svg {...props}>
          <path d="M12 3 L13.2 10.8 L21 12 L13.2 13.2 L12 21 L10.8 13.2 L3 12 L10.8 10.8 Z" />
        </svg>
      );
  }
}
